import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { loadableReady } from '@loadable/component';
import type {
  OnError,
  OnAnalyticsEvent,
} from '@johnlewispartnership/wtr-content-component-library/dist/component-library/config/types';

import {
  CONTENT_DATA_ATTRIBUTE,
  PATH_DATA_ATTRIBUTE,
  WINDOW_DATA_PROPERTY_NAME,
} from 'constants/render';
import { CHUNK_LOADING_GLOBAL } from 'constants/loadable';
import Entrypoint from 'renderer/Entrypoint';

const onAnalyticsEvent: OnAnalyticsEvent = analyticsEventData => {
  if (window.dataLayer) {
    window.dataLayer.push({ ...analyticsEventData });
    return;
  }

  console.warn('dataLayer is not available on the window.');
};

const onError: OnError = (error, additionalData) => {
  if (window.apm) {
    window.apm.captureError(Object.assign({ error, additionalData }));
    return;
  }

  console.warn('APM is not available on the window.');
};

export const renderClient = () => {
  const rootContainer = document.currentScript?.closest(`[${PATH_DATA_ATTRIBUTE}]`);
  const contentRoot = rootContainer?.querySelector(`[${CONTENT_DATA_ATTRIBUTE}]`);
  const namespace = rootContainer?.getAttribute(PATH_DATA_ATTRIBUTE);

  if (!rootContainer || !contentRoot || !namespace) {
    return console.error('Content Renderer: Root container or content root not found');
  }

  const { content, config } = window[WINDOW_DATA_PROPERTY_NAME];

  const componentData = content?.[namespace] || [];

  loadableReady(
    () =>
      hydrateRoot(
        contentRoot,
        <Entrypoint
          componentLibraryConfig={{ ...config, onError, onAnalyticsEvent }}
          componentData={componentData}
        />,
        { identifierPrefix: `wtr-cr-${namespace}` },
      ),
    // @ts-expect-error incorrect types, it is there in the code, promise
    { namespace, chunkLoadingGlobal: CHUNK_LOADING_GLOBAL },
  );
};
